import { ThemeOptions } from "@mui/material";
import { createBoilerplateTheme } from "@gisce/oficina-virtual-components";

import logo from '/images/logo.png'
import logoBar from '/images/logoBar.png'

const customConstants: ThemeOptions = {
  palette: {
    primary: {
      main: "#ac0a32",
    },
    secondary: {
      main: "#ac0a32",
    }
  },
  custom: {
    components: {
      publicityBanner: {
        stylingProps: {
          informationButtonProps: {
            sx: {
              color: 'white'
            }
          },
        },
      },
    },
    constants: {
      logoImage: logo,
      logoBarImage: logoBar,
      borderRadius: 10,
    }
  }
};

export default createBoilerplateTheme(customConstants)

